import { useState } from "react";
import { Outlet } from "react-router";
import { YardProvider } from "@/providers/yard-context";
import { YardActions } from "./yard-actions";
import { YardHeader } from "./yard-header";
import { YardNav } from "./yard-nav";

export function YardLayout() {
  const [navOpen, setNavOpen] = useState(false);
  const [actionsOpen, setActionsOpen] = useState(false);

  return (
    <YardProvider>
      {/*
        Consume the bounded height handed down by the global Layout's content
        container (h-full, not another viewport) with overflow contained and
        min-h-0 on the flex descendants, so pages sized with h-full — e.g. the
        diffusion queue table — resolve against a definite height and scroll
        their own body instead of growing the page. `main` keeps overflow-y-auto
        so placeholder sibling pages taller than the area still scroll under the
        fixed header/nav.
      */}
      <div className="flex h-full flex-col overflow-hidden bg-zinc-50 dark:bg-zinc-950">
        <YardHeader
          onToggleNav={() => setNavOpen(true)}
          onToggleActions={() => setActionsOpen(true)}
        />

        <div className="flex min-h-0 flex-1">
          <YardNav open={navOpen} onOpenChange={setNavOpen} />

          <main className="min-h-0 flex-1 overflow-y-auto overscroll-none">
            <Outlet />
          </main>
        </div>

        <YardActions open={actionsOpen} onOpenChange={setActionsOpen} />
      </div>
    </YardProvider>
  );
}
